import styled from "styled-components";
import {Box, Card} from "rebass";
import {CheckCircle, MapMarkerAlt} from "styled-icons/fa-solid";
import { Bubble } from "styled-icons/icomoon";
import { People } from "styled-icons/material";


export const PanelWrapper = styled(Card)`
//min-width: 250px;
//	height: calc(100vh - 131px);
//	margin-bottom: 10px;
	max-height: calc(45vh - 65px);
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  //@media(max-width: 700px){
  //	height: 70vh;
  //
  //}
`;

/* icon imports */
export const SidebarWrapper = styled(Card)`
  min-width: 260px;
    height: calc(100vh - 131px);
    margin-bottom: 10px;
    overflow-x: auto; /* [1] */
    -webkit-overflow-scrolling: touch; /* [4] */
    -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
    @media(max-width: 700px){
      height: calc(100vh - 194px);
    }
`;

export const SidebarBox = styled(Box)`
  min-width: 260px;
`

export const Check = styled(CheckCircle)`
  width: 20px;
  height: 20px;
  color: white;
`;

export const MapMarker = styled(MapMarkerAlt)`
  width: 20px;
  height: 20px;
  color: white;
`;

export const Chat = styled(Bubble)`
  width: 20px;
  height: 20px;
  color: white;
`;

export const Person = styled(People)`
  width: 20px;
  height: 20px;
  color: white;
`;
